<!-- Se abre en un modal desde la ficha del cliente, que ya pone el título -->
<div>
  <app-page-header
    [className]="'mb-3!'"
    [showCreateButton]="permissionAuth.canCreate('clientes')"
    [textButton]="'Nuevo objetivo'"
    (onCreateClick)="openCreateModal()"
  />

  @if (!loading && objetivos.length) {
    <div class="mb-6 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-6 dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="grid grid-cols-2 gap-4 xl:grid-cols-4">
        <div class="rounded-2xl bg-gray-100 p-4 dark:bg-white/[0.06]">
          <p class="text-sm text-gray-500 dark:text-gray-400">Objetivos</p>
          <p class="mt-2 text-3xl font-semibold text-gray-900 dark:text-white">{{ resumen.total }}</p>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ resumen.evaluables }} con meta evaluable</p>
        </div>

        <div class="rounded-2xl bg-success-50 p-4 dark:bg-success-500/10">
          <p class="text-sm text-gray-500 dark:text-gray-400">Cumplidos</p>
          <p class="mt-2 text-3xl font-semibold text-gray-900 dark:text-white">{{ resumen.cumplidos }}</p>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Alcanzaron la meta de preñeces</p>
        </div>

        <div class="rounded-2xl bg-brand-50 p-4 dark:bg-brand-500/10">
          <p class="text-sm text-gray-500 dark:text-gray-400">En curso</p>
          <p class="mt-2 text-3xl font-semibold text-gray-900 dark:text-white">{{ resumen.enCurso }}</p>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Período abierto, meta pendiente</p>
        </div>

        <div class="rounded-2xl bg-warning-50 p-4 dark:bg-warning-500/10">
          <p class="text-sm text-gray-500 dark:text-gray-400">Requieren atención</p>
          <p class="mt-2 text-3xl font-semibold text-gray-900 dark:text-white">{{ resumen.atencion }}</p>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">No cumplidos o con diagnósticos abiertos</p>
        </div>
      </div>

      @if (resumen.evaluables) {
        <div class="mt-5">
          <div class="mb-2 flex flex-wrap items-baseline justify-between gap-2">
            <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Objetivos cumplidos sobre evaluables</p>
            <p class="text-sm text-gray-500 dark:text-gray-400">{{ resumen.cumplidos }} / {{ resumen.evaluables }} — {{ resumen.porcentajeCumplidos }} %</p>
          </div>
          <app-progress-bar
            [value]="resumen.porcentajeCumplidos"
            [color]="resumen.porcentajeCumplidos === 100 ? 'success' : 'primary'"
            [ariaLabel]="'Objetivos cumplidos sobre evaluables'"
          />
        </div>
      }

      @if (resumen.hayCoincidencias) {
        <p class="mt-4 text-xs text-warning-700 dark:text-orange-400">
          Algunos objetivos comparten los mismos trabajos
        </p>
      }
    </div>
  }

  <app-data-table
    class="min-w-0 max-w-full [&_.table-vitrotech]:overflow-x-auto [&_table]:w-full [&_table]:min-w-[1100px]"
    [columns]="columns"
    [data]="objetivos"
    [loading]="loading"
    [clickableRows]="false"
    [emptyTitle]="'No hay objetivos registrados'"
    [emptySubtitle]="'Cuando se registren objetivos de producción del cliente aparecerán aquí'"
  >
    <!--Contrato: opcional, el objetivo puede cargarse antes de firmarlo-->
    <ng-template appTableCell="contrato" let-objetivo>
      @if (objetivo.contrato) {
        {{ objetivo.contrato.nro_contrato || ('Contrato #' + objetivo.contrato.id) }}
      } @else {
        <span class="text-gray-400 dark:text-gray-500">Sin contrato</span>
      }
    </ng-template>

    <!--Establecimiento-->
    <ng-template appTableCell="establecimiento" let-objetivo>
      {{ objetivo.establecimiento?.nombre || (objetivo.cli_establecimiento_id ? 'Establecimiento no disponible' : 'Todos los establecimientos del cliente') }}
    </ng-template>

    <!--Objetivo-->
    <ng-template appTableCell="objetivo" let-objetivo>
      {{ objetivoLabel(objetivo.objetivo) }}
    </ng-template>

    <!--Avance: barra de cumplimiento visible sin abrir el detalle-->
    <ng-template appTableCell="avance" let-objetivo>
      @let avance = avanceVisual(objetivo);
      @switch (avance.tipo) {
        @case ('meta') {
          <div class="min-w-[180px] space-y-1.5">
            <div class="flex items-baseline justify-between gap-2">
              <span class="text-sm font-medium text-gray-800 dark:text-white/90">{{ avance.conteo }}</span>
              <span class="text-sm text-gray-500 dark:text-gray-400">{{ avance.porcentaje }} %</span>
            </div>
            <app-progress-bar
              [value]="avance.porcentaje"
              [color]="avance.color"
              size="sm"
              [ariaLabel]="'Avance de preñeces: ' + avance.porcentaje + ' por ciento'"
            />
            <span class="text-xs text-gray-500 dark:text-gray-400">{{ avance.detalle }}</span>
          </div>
        }
        @case ('actividad') {
          <div class="min-w-[180px]">
            <span class="text-sm font-medium text-gray-800 dark:text-white/90">{{ avance.conteo }}</span>
            <span class="block text-xs text-gray-500 dark:text-gray-400">{{ avance.detalle }}</span>
          </div>
        }
        @default {
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ avance.detalle }}</span>
        }
      }
    </ng-template>

    <ng-template appTableCell="pendientes" let-objetivo>
      @if (objetivo.seguimiento?.diagnosticos_pendientes; as pendientes) {
        <app-badge [color]="'warning'">{{ pendientes }}</app-badge>
      } @else if (objetivo.seguimiento?.diagnosticos_pendientes === 0) {
        <span class="text-sm text-gray-500 dark:text-gray-400">0</span>
      } @else {
        <span class="text-sm text-gray-500 dark:text-gray-400">—</span>
      }
    </ng-template>

    <ng-template appTableCell="estado" let-objetivo>
      @if (objetivo.seguimiento; as seguimiento) {
        <app-badge [color]="estadoSeguimiento(seguimiento.estado).color">
          {{ estadoSeguimiento(seguimiento.estado).label }}
        </app-badge>
        @if (seguimiento.objetivos_coincidentes.length) {
          <span class="mt-1 block text-xs text-gray-500 dark:text-gray-400">Resultados compartidos con otros objetivos</span>
        }
      } @else {
        <span>No disponible</span>
      }
    </ng-template>
    <ng-template appTableCell="acciones" let-objetivo let-index="index">
      <div class="flex items-center gap-x-2.5">
        <button
          (click)="openViewModal(objetivo.id)"
          [matTooltip]="'Ver objetivo'"
        >
          <mat-icon class="dark:text-gray-400!">visibility</mat-icon>
        </button>

        <app-delete-trigger *hasPermission="'clientes.registros:delete'"
          [title]="'Eliminar objetivo'"
          [disabled]="deleting && (index === deletingIndex)"
          (clickDeleteEvent)="delete(objetivo.id, index)"
        />
      </div>
    </ng-template>
  </app-data-table>
</div>
